module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.authenticated) ? _c('div', [_c('router-view', {
    attrs: {
      "name": "fullscreen"
    }
  }), _vm._v(" "), (_vm.showErrorPage) ? _c('error-page') : _vm._e(), _vm._v(" "), _c('error-bubble'), _vm._v(" "), _c('navbar', {
    attrs: {
      "showBurger": _vm.hideSidebar
    },
    on: {
      "toggleSidebar": function($event) {
        _vm.hideSidebar = !_vm.hideSidebar
      }
    }
  }), _vm._v(" "), _c('sidebar', {
    class: {
      'is-hidden-touch': _vm.hideSidebar
    }
  }), _vm._v(" "), _c('app-main')], 1) : _c('div', [_c('login')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fdd2154"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 212
// module chunks = 1